import gql from 'graphql-tag';

export const OM_PROTECT_STORE_FIELDS = gql`
  fragment OmProtectStoreFields on OmProtectStore {
    id
    testatorId
    propertiesCents
    valuablesCents
    investmentsCents
    businessInterestCents
    cashAndSavingsCents
    homeLoansCents
    personalLoansCents
    creditCardsCents
    overdraftFacilitiesCents
    existingCoverCents
    funeralExpensesCents
    bequestToSpouseCents
    section4aAbatementCents
    everDeclaredInsolvent
    debtRehabilitationCompleted
    debtRehabilitationDate
    assetOthers {
      id
      category
      description
      amountCents
    }
    liabilityOthers {
      id
      category
      description
      amountCents
    }
    deductionOthers {
      id
      category
      description
      amountCents
    }
    totalAssets
    totalLiabilities
    netAssets
    totalValueOfAssets
    executorFees
    totalDeductions
    netEstate
    dutiableEstate
    estateDutyPayable
    skipped
  }
`;

export const UPDATE_OM_PROTECT_STORE_MUTATION = gql`
  ${OM_PROTECT_STORE_FIELDS}
  mutation updateOmProtectStore($omProtectStoreInput: OmProtectStoreInput!) {
    updateOmProtectStore(omProtectStoreInput: $omProtectStoreInput) {
      ...OmProtectStoreFields
    }
  }
`;

export const OM_PROTECT_STORE_PDF_URL_QUERY = gql`
  query omProtectStorePdfUrl($testatorId: ID!) {
    omProtectStorePdfUrl(testatorId: $testatorId) {
      url
      status
    }
  }
`;

export const MARK_OM_PROTECT_PDF_DOWNLOADED_MUTATION = gql`
  mutation markOmProtectPdfDownloaded($testatorId: ID!) {
    markOmProtectPdfDownloaded(testatorId: $testatorId)
  }
`;
